/**
 * @generated SignedSource<<67029924302baa34b61ffbde825702c1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type OnboardingItemKey = "ADD_PEOPLE_BANNER" | "CLASSIC_TO_ATLASSIAN_HOME_MODAL" | "DISCOVER_INTEGRATIONS" | "EXPLORE_DIRECTORY_BANNER" | "GLOBAL_HOME" | "GOALS_ABOUT_TAB_BANNER" | "GOALS_APP_CHANGEBOARDING" | "GOALS_DIRECTORY" | "GOALS_DIRECTORY_BANNER" | "GOALS_METRICS_POPUP" | "GOALS_UPDATES_BANNER" | "GOALS_UPDATES_TAB_BANNER" | "GOAL_LEARNINGS_BANNER" | "LINKED_GOALS_IN_JIRA_BANNER" | "NAV_REFRESH_ADMIN_OPT_IN" | "NAV_REFRESH_OPT_OUT" | "NO_WORKSPACE_BENEFITS_DIALOG" | "PASTE_WORK_TRACKING_JIRA_LINK_BANNER" | "PRODUCT_OVERVIEW" | "PROJECT_ABOUT_TAB_BANNER" | "PROJECT_DIRECTORY" | "PROJECT_DIRECTORY_BANNER" | "PROJECT_LEARNINGS_BANNER" | "PROJECT_SPOTLIGHT" | "PROJECT_UPDATES_TAB_BANNER" | "PROJECT_UPDATE_BANNER" | "QUESTIONS_FEED_BANNER" | "READING_MODE_FEEDBACK_COLLECTION" | "STAFF_DIRECTORY_UPLOAD_HIGH_RES_PIC" | "SYNC_WITH_JIRA_BANNER" | "TEAMS_APP" | "TEAMS_APP_CHANGEBOARDING" | "TEAMS_DIRECTORY" | "TOPICS_DIRECTORY" | "WRITING_MODE_FEEDBACK_COLLECTION";
export type ProjectStateValue = "archived" | "at_risk" | "cancelled" | "done" | "off_track" | "on_track" | "paused" | "pending";
export type TrackViewEvent = "DIRECT" | "INDIRECT" | "SKIP";
export type ProjectViewQuery$variables = {
  areMilestonesEnabled: boolean;
  cloudId?: string | null;
  isNavRefreshEnabled: boolean;
  key: string;
  onboardingKeyFilter: OnboardingItemKey;
  trackViewEvent?: TrackViewEvent | null;
  workspaceId?: string | null;
};
export type ProjectViewQuery$data = {
  readonly currentUser: {
    readonly aaid: string | null;
    readonly onboarding: {
      readonly edges: ReadonlyArray<{
        readonly __typename: "OnboardingEdge";
      } | null> | null;
    } | null;
  } | null;
  readonly project: {
    readonly archived: boolean;
    readonly key: string;
    readonly members: {
      readonly " $fragmentSpreads": FragmentRefs<"utils_isUserInList">;
    } | null;
    readonly name: string;
    readonly owner: {
      readonly aaid: string | null;
    } | null;
    readonly private: boolean;
    readonly state: {
      readonly value: ProjectStateValue | null;
    } | null;
    readonly uuid: string;
    readonly watchers: {
      readonly " $fragmentSpreads": FragmentRefs<"utils_isUserInList">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectArchivedPanel" | "ProjectContent" | "ProjectHeader" | "ProjectSidebar" | "ProjectTabs" | "useRedirectToDefaultTab">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"OnboardingSpotlightTour">;
};
export type ProjectViewQuery = {
  response: ProjectViewQuery$data;
  variables: ProjectViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "areMilestonesEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isNavRefreshEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "onboardingKeyFilter"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "trackViewEvent"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v7 = {
  "kind": "Variable",
  "name": "key",
  "variableName": "key"
},
v8 = [
  (v7/*: any*/),
  {
    "kind": "Variable",
    "name": "trackViewEvent",
    "variableName": "trackViewEvent"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v10 = {
  "kind": "ScalarField",
  "name": "name"
},
v11 = {
  "kind": "ScalarField",
  "name": "key"
},
v12 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v13 = [
  (v12/*: any*/)
],
v14 = [
  {
    "kind": "InlineDataFragmentSpread",
    "name": "utils_isUserInList",
    "selections": [
      {
        "concreteType": "UserEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": (v13/*: any*/)
          }
        ]
      }
    ],
    "argumentDefinitions": ([]/*: any*/)
  }
],
v15 = {
  "kind": "ScalarField",
  "name": "private"
},
v16 = {
  "kind": "ScalarField",
  "name": "archived"
},
v17 = {
  "kind": "ScalarField",
  "name": "value"
},
v18 = [
  (v17/*: any*/)
],
v19 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v20 = {
  "kind": "Variable",
  "name": "workspaceId",
  "variableName": "workspaceId"
},
v21 = [
  (v20/*: any*/)
],
v22 = [
  {
    "fields": [
      {
        "items": [
          {
            "kind": "Variable",
            "name": "keys.0",
            "variableName": "onboardingKeyFilter"
          }
        ],
        "kind": "ListValue",
        "name": "keys"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v23 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v24 = {
  "concreteType": "OnboardingEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    (v23/*: any*/)
  ]
},
v25 = {
  "kind": "ScalarField",
  "name": "id"
},
v26 = [
  (v12/*: any*/),
  (v25/*: any*/)
],
v27 = {
  "concreteType": "UserEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v26/*: any*/)
    }
  ]
},
v28 = {
  "kind": "ScalarField",
  "name": "count"
},
v29 = {
  "concreteType": "IconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "ThemeURIs",
      "kind": "LinkedField",
      "name": "square",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "light"
        },
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "transparent"
        }
      ]
    }
  ]
},
v30 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v31 = {
  "kind": "ScalarField",
  "name": "targetDate"
},
v32 = {
  "kind": "ScalarField",
  "name": "watching"
},
v33 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v34 = [
  (v33/*: any*/),
  {
    "kind": "Literal",
    "name": "type",
    "value": "LEARNING"
  }
],
v35 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v36 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v37 = [
  {
    "concreteType": "LearningEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      (v23/*: any*/),
      (v35/*: any*/),
      {
        "concreteType": "Learning",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v23/*: any*/),
          (v25/*: any*/)
        ]
      }
    ]
  },
  (v36/*: any*/)
],
v38 = [
  "type"
],
v39 = [
  (v33/*: any*/),
  {
    "kind": "Literal",
    "name": "type",
    "value": "RISK"
  }
],
v40 = [
  (v33/*: any*/),
  {
    "kind": "Literal",
    "name": "type",
    "value": "DECISION"
  }
],
v41 = {
  "kind": "ScalarField",
  "name": "ari"
},
v42 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v43 = {
  "kind": "ScalarField",
  "name": "picture"
},
v44 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v45 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v46 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v47 = {
  "kind": "ScalarField",
  "name": "summary"
},
v48 = {
  "kind": "ScalarField",
  "name": "title"
},
v49 = {
  "concreteType": "UserPII",
  "kind": "LinkedField",
  "name": "pii",
  "plural": false,
  "selections": [
    (v43/*: any*/),
    (v10/*: any*/),
    (v44/*: any*/),
    (v45/*: any*/),
    {
      "concreteType": "ExtendedProfile",
      "kind": "LinkedField",
      "name": "extendedProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jobTitle"
        }
      ]
    }
  ]
},
v50 = [
  (v12/*: any*/),
  (v49/*: any*/),
  (v25/*: any*/)
],
v51 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": "connectionId",
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v52 = [
  (v25/*: any*/)
],
v53 = {
  "kind": "InlineFragment",
  "selections": (v52/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v54 = [
  (v28/*: any*/)
],
v55 = {
  "kind": "ScalarField",
  "name": "type"
},
v56 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": "connId",
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v57 = {
  "kind": "ScalarField",
  "name": "label"
},
v58 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    }
  ]
},
v59 = {
  "kind": "ScalarField",
  "name": "url"
},
v60 = {
  "kind": "ScalarField",
  "name": "description"
},
v61 = {
  "kind": "LinkedField",
  "name": "definition",
  "plural": false,
  "selections": [
    (v23/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v10/*: any*/),
        (v60/*: any*/)
      ],
      "type": "CustomFieldDefinitionNode",
      "abstractKey": "__isCustomFieldDefinitionNode"
    },
    (v53/*: any*/)
  ]
},
v62 = {
  "kind": "InlineFragment",
  "selections": [
    (v55/*: any*/)
  ],
  "type": "CustomFieldDefinitionNode",
  "abstractKey": "__isCustomFieldDefinitionNode"
},
v63 = {
  "kind": "ScalarField",
  "name": "canSetMultipleValues"
},
v64 = [
  (v63/*: any*/)
],
v65 = {
  "kind": "InlineFragment",
  "selections": (v64/*: any*/),
  "type": "UserCustomFieldDefinition"
},
v66 = {
  "kind": "InlineFragment",
  "selections": (v64/*: any*/),
  "type": "TextSelectCustomFieldDefinition"
},
v67 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "definition",
      "plural": false,
      "selections": [
        (v62/*: any*/),
        (v65/*: any*/),
        (v66/*: any*/)
      ]
    }
  ],
  "type": "CustomFieldNode",
  "abstractKey": "__isCustomFieldNode"
},
v68 = [
  (v25/*: any*/),
  (v17/*: any*/)
],
v69 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectViewQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v8/*: any*/),
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "projectByKey",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": (v13/*: any*/)
          },
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "members",
            "plural": false,
            "selections": (v14/*: any*/)
          },
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": (v14/*: any*/)
          },
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "concreteType": "ProjectState",
            "kind": "LinkedField",
            "name": "state",
            "plural": false,
            "selections": (v18/*: any*/)
          },
          {
            "kind": "FragmentSpread",
            "name": "ProjectArchivedPanel"
          },
          {
            "kind": "FragmentSpread",
            "name": "ProjectHeader"
          },
          {
            "kind": "FragmentSpread",
            "name": "ProjectTabs"
          },
          {
            "condition": "isNavRefreshEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "ProjectContent"
              }
            ]
          },
          {
            "condition": "isNavRefreshEnabled",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "areMilestonesEnabled",
                    "variableName": "areMilestonesEnabled"
                  },
                  (v19/*: any*/),
                  (v7/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "ProjectSidebar"
              }
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "useRedirectToDefaultTab"
          }
        ]
      },
      {
        "args": (v21/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          {
            "args": (v22/*: any*/),
            "concreteType": "OnboardingConnection",
            "kind": "LinkedField",
            "name": "onboarding",
            "plural": false,
            "selections": [
              (v24/*: any*/)
            ]
          }
        ]
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "onboardingKeyFilter",
            "variableName": "onboardingKeyFilter"
          },
          (v20/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "OnboardingSpotlightTour"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectViewQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v8/*: any*/),
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "projectByKey",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": (v26/*: any*/)
          },
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "members",
            "plural": false,
            "selections": [
              (v27/*: any*/)
            ]
          },
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": [
              (v27/*: any*/),
              (v28/*: any*/)
            ]
          },
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "concreteType": "ProjectState",
            "kind": "LinkedField",
            "name": "state",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              {
                "concreteType": "CompletionProjectState",
                "kind": "LinkedField",
                "name": "atCompletionState",
                "plural": false,
                "selections": (v18/*: any*/)
              }
            ]
          },
          (v25/*: any*/),
          {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
              (v25/*: any*/),
              {
                "kind": "ScalarField",
                "name": "color"
              },
              {
                "kind": "ScalarField",
                "name": "shortName"
              }
            ]
          },
          (v29/*: any*/),
          (v30/*: any*/),
          {
            "kind": "ScalarField",
            "name": "startDate"
          },
          (v31/*: any*/),
          {
            "kind": "ScalarField",
            "name": "targetDateConfidence"
          },
          (v32/*: any*/),
          {
            "kind": "ScalarField",
            "name": "userUpdateCount"
          },
          {
            "alias": "learningsCount",
            "args": (v34/*: any*/),
            "concreteType": "LearningConnection",
            "kind": "LinkedField",
            "name": "learnings",
            "plural": false,
            "selections": (v37/*: any*/),
            "storageKey": "learnings(first:100,type:\"LEARNING\")"
          },
          {
            "alias": "learningsCount",
            "args": (v34/*: any*/),
            "filters": (v38/*: any*/),
            "handle": "connection",
            "key": "ProjectTabs__learningsCount",
            "kind": "LinkedHandle",
            "name": "learnings"
          },
          {
            "alias": "risksCount",
            "args": (v39/*: any*/),
            "concreteType": "LearningConnection",
            "kind": "LinkedField",
            "name": "learnings",
            "plural": false,
            "selections": (v37/*: any*/),
            "storageKey": "learnings(first:100,type:\"RISK\")"
          },
          {
            "alias": "risksCount",
            "args": (v39/*: any*/),
            "filters": (v38/*: any*/),
            "handle": "connection",
            "key": "ProjectTabs__risksCount",
            "kind": "LinkedHandle",
            "name": "learnings"
          },
          {
            "alias": "decisionsCount",
            "args": (v40/*: any*/),
            "concreteType": "LearningConnection",
            "kind": "LinkedField",
            "name": "learnings",
            "plural": false,
            "selections": (v37/*: any*/),
            "storageKey": "learnings(first:100,type:\"DECISION\")"
          },
          {
            "alias": "decisionsCount",
            "args": (v40/*: any*/),
            "filters": (v38/*: any*/),
            "handle": "connection",
            "key": "ProjectTabs__decisionsCount",
            "kind": "LinkedHandle",
            "name": "learnings"
          },
          {
            "kind": "ScalarField",
            "name": "theWhat"
          },
          {
            "kind": "ScalarField",
            "name": "theWhy"
          },
          {
            "kind": "ScalarField",
            "name": "theMeasurement"
          },
          {
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v25/*: any*/),
              {
                "concreteType": "WorkspaceAIConfig",
                "kind": "LinkedField",
                "name": "aiConfig",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "enabled"
                  }
                ]
              }
            ]
          },
          (v41/*: any*/),
          {
            "concreteType": "CommentConnection",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
              {
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/),
                      (v42/*: any*/),
                      (v41/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "commentText"
                      },
                      (v30/*: any*/),
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v43/*: any*/),
                              (v10/*: any*/),
                              (v44/*: any*/),
                              (v45/*: any*/)
                            ]
                          },
                          (v25/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v46/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "latestUpdateDate"
          },
          {
            "concreteType": "ProjectUpdate",
            "kind": "LinkedField",
            "name": "latestUserUpdate",
            "plural": false,
            "selections": [
              (v42/*: any*/),
              (v30/*: any*/),
              (v47/*: any*/),
              {
                "concreteType": "UpdateNote",
                "kind": "LinkedField",
                "name": "notes",
                "plural": true,
                "selections": [
                  (v48/*: any*/),
                  (v47/*: any*/),
                  (v25/*: any*/)
                ]
              },
              (v25/*: any*/)
            ]
          },
          {
            "args": [
              {
                "kind": "Literal",
                "name": "hasUpdateId",
                "value": false
              }
            ],
            "concreteType": "ProjectChangelogItemConnection",
            "kind": "LinkedField",
            "name": "changelog",
            "plural": false,
            "selections": [
              (v28/*: any*/),
              {
                "concreteType": "ProjectChangelogItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "ProjectChangelogItem",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "newValue"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "oldValue"
                      },
                      (v25/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "storageKey": "changelog(hasUpdateId:false)"
          },
          {
            "concreteType": "DraftUpdate",
            "kind": "LinkedField",
            "name": "draftUpdate",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "input"
              },
              {
                "kind": "ScalarField",
                "name": "modifiedDate"
              },
              {
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "UserPII",
                    "kind": "LinkedField",
                    "name": "pii",
                    "plural": false,
                    "selections": [
                      (v45/*: any*/),
                      (v10/*: any*/),
                      (v43/*: any*/)
                    ]
                  },
                  (v25/*: any*/)
                ]
              },
              (v25/*: any*/),
              (v46/*: any*/)
            ]
          },
          {
            "condition": "isNavRefreshEnabled",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "watchers",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "UserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v43/*: any*/),
                              (v45/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canEditMembers"
              },
              {
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "UserPII",
                    "kind": "LinkedField",
                    "name": "pii",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v43/*: any*/),
                      (v44/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "email"
                      },
                      (v45/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "ContributorConnection",
                "kind": "LinkedField",
                "name": "contributors",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ContributorEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v50/*: any*/),
                            "type": "User"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v25/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "teamId"
                              },
                              (v10/*: any*/),
                              {
                                "concreteType": "TeamDetails",
                                "kind": "LinkedField",
                                "name": "teamDetails",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "isVerified"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "membershipSettings"
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "avatarUrl"
                              },
                              (v32/*: any*/),
                              {
                                "args": [
                                  (v19/*: any*/)
                                ],
                                "kind": "ScalarField",
                                "name": "permission"
                              },
                              {
                                "args": [
                                  (v7/*: any*/)
                                ],
                                "concreteType": "UserConnection",
                                "kind": "LinkedField",
                                "name": "membersOfProject",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "UserEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v50/*: any*/)
                                      }
                                    ]
                                  },
                                  (v51/*: any*/)
                                ]
                              }
                            ],
                            "type": "Team"
                          },
                          (v53/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v51/*: any*/)
                ]
              },
              {
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "members",
                "plural": false,
                "selections": (v54/*: any*/)
              },
              {
                "concreteType": "GoalConnection",
                "kind": "LinkedField",
                "name": "goals",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          {
                            "concreteType": "GoalIcon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "appearance"
                              }
                            ]
                          },
                          {
                            "concreteType": "GoalProgress",
                            "kind": "LinkedField",
                            "name": "progress",
                            "plural": false,
                            "selections": [
                              (v55/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "percentage"
                              }
                            ]
                          },
                          {
                            "concreteType": "MetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "MetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "MetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "MetricValue",
                                        "kind": "LinkedField",
                                        "name": "snapshotValue",
                                        "plural": false,
                                        "selections": [
                                          (v17/*: any*/),
                                          (v25/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "startValue"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "targetValue"
                                      },
                                      {
                                        "concreteType": "Metric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v55/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "subType"
                                          },
                                          (v25/*: any*/),
                                          (v10/*: any*/),
                                          (v16/*: any*/)
                                        ]
                                      },
                                      (v25/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "GoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": (v54/*: any*/)
                          },
                          (v10/*: any*/),
                          (v11/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v56/*: any*/)
                ]
              },
              {
                "concreteType": "ProjectDependencyConnection",
                "kind": "LinkedField",
                "name": "dependencies",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ProjectDependencyEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "ProjectDependency",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "linkType"
                          },
                          {
                            "concreteType": "Project",
                            "kind": "LinkedField",
                            "name": "outgoingProject",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v25/*: any*/),
                              (v10/*: any*/),
                              (v9/*: any*/),
                              (v15/*: any*/),
                              (v29/*: any*/),
                              {
                                "concreteType": "ProjectState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": [
                                  (v57/*: any*/),
                                  (v58/*: any*/),
                                  {
                                    "alias": "projectStateValue",
                                    "kind": "ScalarField",
                                    "name": "value"
                                  },
                                  {
                                    "concreteType": "CompletionProjectState",
                                    "kind": "LinkedField",
                                    "name": "atCompletionState",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      (v57/*: any*/),
                                      (v58/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "alias": "dependencyId",
                            "kind": "ScalarField",
                            "name": "id"
                          },
                          {
                            "concreteType": "Project",
                            "kind": "LinkedField",
                            "name": "incomingProject",
                            "plural": false,
                            "selections": (v52/*: any*/)
                          },
                          (v25/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v56/*: any*/)
                ]
              },
              {
                "alias": "workTrackingLinks",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  },
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "WORK_TRACKING"
                  }
                ],
                "concreteType": "LinkConnection",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "LinkEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Link",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          (v59/*: any*/),
                          (v10/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v56/*: any*/)
                ],
                "storageKey": "links(first:1,type:\"WORK_TRACKING\")"
              },
              {
                "concreteType": "FusionDetails",
                "kind": "LinkedField",
                "name": "fusion",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "synced"
                  }
                ]
              },
              {
                "concreteType": "Workspace",
                "kind": "LinkedField",
                "name": "workspace",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "Site",
                    "kind": "LinkedField",
                    "name": "site",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ProductActivationConnection",
                        "kind": "LinkedField",
                        "name": "productActivations",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "ProductActivationEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v23/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "atlasForJiraCloudEnabled"
                                      }
                                    ],
                                    "type": "JiraProductActivation"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "alias": "relatedLinks",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "RELATED"
                  }
                ],
                "concreteType": "LinkConnection",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "LinkEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Link",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          (v10/*: any*/),
                          (v59/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v56/*: any*/)
                ],
                "storageKey": "links(type:\"RELATED\")"
              },
              {
                "alias": "milestoneCount",
                "concreteType": "MilestoneConnection",
                "kind": "LinkedField",
                "name": "milestones",
                "plural": false,
                "selections": (v54/*: any*/)
              },
              {
                "concreteType": "TagConnection",
                "kind": "LinkedField",
                "name": "tags",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TagEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Tag",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v60/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "projectUsageCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "goalUsageCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "helpPointerUsageCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "watcherCount"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": "tagConnectionId",
                        "kind": "ScalarField",
                        "name": "__id"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "CustomFieldConnection",
                "kind": "LinkedField",
                "name": "customFields",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "CustomFieldEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v25/*: any*/),
                              (v61/*: any*/),
                              {
                                "concreteType": "CustomFieldTextSavedValueNode",
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": false,
                                "selections": [
                                  (v25/*: any*/),
                                  {
                                    "alias": "textValue",
                                    "kind": "ScalarField",
                                    "name": "value"
                                  }
                                ]
                              },
                              (v67/*: any*/)
                            ],
                            "type": "TextCustomField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v25/*: any*/),
                              (v61/*: any*/),
                              {
                                "concreteType": "CustomFieldNumberSavedValueNode",
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": false,
                                "selections": [
                                  (v25/*: any*/),
                                  {
                                    "alias": "numberValue",
                                    "kind": "ScalarField",
                                    "name": "value"
                                  }
                                ]
                              },
                              (v67/*: any*/)
                            ],
                            "type": "NumberCustomField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v25/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "definition",
                                "plural": false,
                                "selections": [
                                  (v23/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v10/*: any*/),
                                      (v60/*: any*/),
                                      (v63/*: any*/)
                                    ],
                                    "type": "UserCustomFieldDefinition"
                                  },
                                  (v53/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "UserConnection",
                                "kind": "LinkedField",
                                "name": "values",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "UserEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v25/*: any*/),
                                          (v12/*: any*/),
                                          (v49/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  (v51/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "definition",
                                    "plural": false,
                                    "selections": [
                                      (v62/*: any*/),
                                      (v66/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "CustomFieldNode",
                                "abstractKey": "__isCustomFieldNode"
                              }
                            ],
                            "type": "UserCustomField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v25/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "definition",
                                "plural": false,
                                "selections": [
                                  (v23/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v10/*: any*/),
                                      (v60/*: any*/),
                                      (v63/*: any*/),
                                      {
                                        "concreteType": "CustomFieldTextAllowedValueConnection",
                                        "kind": "LinkedField",
                                        "name": "allowedValues",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "CustomFieldTextAllowedValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "CustomFieldTextAllowedValueNode",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": (v68/*: any*/)
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "TextSelectCustomFieldDefinition"
                                  },
                                  (v53/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "CustomFieldTextSavedValueConnection",
                                "kind": "LinkedField",
                                "name": "values",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CustomFieldTextSavedValueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "CustomFieldTextSavedValueNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v68/*: any*/)
                                      }
                                    ]
                                  },
                                  (v51/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "definition",
                                    "plural": false,
                                    "selections": [
                                      (v62/*: any*/),
                                      (v65/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "CustomFieldNode",
                                "abstractKey": "__isCustomFieldNode"
                              }
                            ],
                            "type": "TextSelectCustomField"
                          },
                          (v53/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "targetDateSet"
              },
              {
                "condition": "areMilestonesEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v69/*: any*/),
                    "concreteType": "MilestoneConnection",
                    "kind": "LinkedField",
                    "name": "milestones",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "MilestoneEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "Milestone",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "status"
                              },
                              (v48/*: any*/),
                              (v31/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "targetDateType"
                              },
                              (v46/*: any*/),
                              (v23/*: any*/)
                            ]
                          },
                          (v35/*: any*/)
                        ]
                      },
                      (v36/*: any*/),
                      (v46/*: any*/)
                    ],
                    "storageKey": "milestones(first:20)"
                  },
                  {
                    "args": (v69/*: any*/),
                    "handle": "connection",
                    "key": "Project__milestones",
                    "kind": "LinkedHandle",
                    "name": "milestones"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "args": (v21/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          {
            "args": (v22/*: any*/),
            "concreteType": "OnboardingConnection",
            "kind": "LinkedField",
            "name": "onboarding",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              (v46/*: any*/)
            ]
          },
          (v25/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "bfbb863ed52b78d9e84e8c8086e7059e",
    "id": null,
    "metadata": {},
    "name": "ProjectViewQuery",
    "operationKind": "query",
    "text": "query ProjectViewQuery(\n  $key: String!\n  $trackViewEvent: TrackViewEvent\n  $workspaceId: ID\n  $onboardingKeyFilter: OnboardingItemKey!\n  $areMilestonesEnabled: Boolean!\n  $cloudId: String\n  $isNavRefreshEnabled: Boolean!\n) {\n  project: projectByKey(key: $key, trackViewEvent: $trackViewEvent) {\n    uuid\n    name\n    key\n    owner {\n      aaid\n      id\n    }\n    members {\n      ...utils_isUserInList\n    }\n    watchers {\n      ...utils_isUserInList\n    }\n    private\n    archived\n    state {\n      value\n    }\n    ...ProjectArchivedPanel\n    ...ProjectHeader\n    ...ProjectTabs\n    ...ProjectContent @include(if: $isNavRefreshEnabled)\n    ...ProjectSidebar_2SVbDg @skip(if: $isNavRefreshEnabled)\n    ...useRedirectToDefaultTab\n    id\n  }\n  currentUser(workspaceId: $workspaceId) {\n    aaid\n    onboarding(filter: {keys: [$onboardingKeyFilter]}) {\n      edges {\n        __typename\n      }\n    }\n    id\n  }\n  ...OnboardingSpotlightTour_2tC7yX\n}\n\nfragment AddOrEditButton on CustomFieldNode {\n  __isCustomFieldNode: __typename\n  id\n  definition {\n    __typename\n    ... on CustomFieldDefinitionNode {\n      __isCustomFieldDefinitionNode: __typename\n      type\n    }\n    ... on UserCustomFieldDefinition {\n      canSetMultipleValues\n    }\n    ... on TextSelectCustomFieldDefinition {\n      canSetMultipleValues\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment Comment on Comment {\n  id\n  ari\n  commentText\n  creationDate\n  editDate\n  creator {\n    aaid\n    ...UserAvatar\n    id\n  }\n}\n\nfragment Comments on CommentConnection {\n  edges {\n    node {\n      id\n      editDate\n      ...Comment\n    }\n  }\n}\n\nfragment DraftUpdate on DraftUpdate {\n  input\n  modifiedDate\n  author {\n    pii {\n      accountId\n      name\n      picture\n    }\n    id\n  }\n}\n\nfragment FollowersSidebarSection on UserConnection {\n  count\n  edges {\n    node {\n      pii {\n        name\n        picture\n        accountId\n      }\n      id\n    }\n  }\n}\n\nfragment FollowersSidebarSection_Owner on UserPII {\n  accountId\n}\n\nfragment FollowersSidebarSection_ProjectKey on Project {\n  key\n}\n\nfragment FreeformNumberField on NumberCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on CustomFieldDefinitionNode {\n      __isCustomFieldDefinitionNode: __typename\n      name\n      description\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  value {\n    id\n    numberValue: value\n  }\n}\n\nfragment FreeformTextField on TextCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on CustomFieldDefinitionNode {\n      __isCustomFieldDefinitionNode: __typename\n      name\n      description\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  value {\n    id\n    textValue: value\n  }\n}\n\nfragment GenericWorkTrackingLinks on Project {\n  id\n  workTrackingLinks: links(type: WORK_TRACKING, first: 1) {\n    ...ProjectLinks\n  }\n}\n\nfragment GoalItem on Goal {\n  ...PlatformGoalIcon\n  ...progressBarMetricTarget\n  ...metricTargetPopup\n  progress {\n    percentage\n  }\n  name\n  key\n  id\n}\n\nfragment InviteUserPromptPopup on Project {\n  watchers {\n    count\n  }\n}\n\nfragment LinkedGoals on Project {\n  id\n  uuid\n  goals {\n    edges {\n      node {\n        id\n        ...GoalItem\n      }\n    }\n  }\n}\n\nfragment LinkedProject on ProjectDependency {\n  dependencyId: id\n  incomingProject {\n    id\n  }\n  outgoingProject {\n    id\n    ...ProjectName_data\n    state {\n      ...ProjectState\n    }\n  }\n}\n\nfragment LinkedProjects on Project {\n  id\n  key\n  dependencies {\n    edges {\n      node {\n        linkType\n        outgoingProject {\n          key\n          id\n        }\n        ...LinkedProject\n        id\n      }\n    }\n  }\n}\n\nfragment MetaActions on Project {\n  key\n  private\n  ...ProjectStateAndTargetDate\n  ...ProjectFollowButton\n  ...InviteUserPromptPopup\n  ...ProjectActions\n}\n\nfragment MilestoneFields on Milestone {\n  id\n  title\n  targetDate\n  targetDateType\n  status\n}\n\nfragment Milestones on Project {\n  creationDate\n  startDate\n  milestones(first: 20) {\n    edges {\n      node {\n        id\n        status\n        ...MilestoneFields\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment NewProjectUpdate on Project {\n  id\n  key\n  uuid\n  workspace {\n    uuid\n    id\n    aiConfig {\n      enabled\n    }\n  }\n  watchers {\n    count\n  }\n  creationDate\n  startDate\n  targetDate\n  state {\n    value\n  }\n  latestUserUpdate {\n    editDate\n    creationDate\n    summary\n    notes {\n      title\n      summary\n      id\n    }\n    id\n  }\n  ...ProjectTargetDateAutoUpdated\n  draftUpdate {\n    ...DraftUpdate\n    input\n    id\n  }\n}\n\nfragment OnboardingSpotlightTour_2tC7yX on Query {\n  currentUser(workspaceId: $workspaceId) {\n    id\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ProjectAboutTab on Project {\n  ...ProjectDescription\n  ...ProjectComments\n}\n\nfragment ProjectActions on Project {\n  id\n  name\n  archived\n  private\n}\n\nfragment ProjectArchivedPanel on Project {\n  id\n  state {\n    value\n  }\n}\n\nfragment ProjectComments on Project {\n  id\n  uuid\n  ari\n  workspace {\n    uuid\n    id\n  }\n  comments {\n    edges {\n      node {\n        id\n      }\n    }\n    ...Comments\n  }\n}\n\nfragment ProjectContent on Project {\n  watching\n  userUpdateCount\n  ...ProjectAboutTab\n  ...ProjectUpdatesTab\n}\n\nfragment ProjectContributors_OtPnR on Project {\n  id\n  name\n  key\n  canEditMembers\n  private\n  owner {\n    aaid\n    id\n  }\n  contributors {\n    edges {\n      node {\n        __typename\n        ... on User {\n          aaid\n          ...UserItem\n        }\n        ... on Team {\n          id\n          teamId\n          name\n          ...TeamAndMembersItem_OtPnR\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  members {\n    count\n    edges {\n      node {\n        aaid\n        id\n      }\n    }\n  }\n}\n\nfragment ProjectDescription on Project {\n  id\n  uuid\n  name\n  theWhat\n  theWhy\n  theMeasurement\n  workspace {\n    uuid\n    id\n  }\n}\n\nfragment ProjectFollowButton on Project {\n  id\n  uuid\n  watching\n}\n\nfragment ProjectHeader on Project {\n  id\n  name\n  key\n  ...ProjectKey\n  ...ProjectIconPicker\n  ...ProjectStateAndTargetDate\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectIconPicker on Project {\n  id\n  uuid\n  icon {\n    id\n    color\n    shortName\n  }\n  ...ProjectIcon\n}\n\nfragment ProjectKey on Project {\n  key\n}\n\nfragment ProjectLinks on LinkConnection {\n  edges {\n    node {\n      id\n      name\n      url\n    }\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment ProjectOwner on Project {\n  id\n  key\n  canEditMembers\n  owner {\n    aaid\n    pii {\n      name\n      picture\n      accountStatus\n      email\n    }\n    ...UserAvatar\n    id\n  }\n}\n\nfragment ProjectSidebar_2SVbDg on Project {\n  ari\n  id\n  key\n  ...MetaActions\n  ...ProjectOwner\n  ...ProjectContributors_OtPnR\n  ...LinkedGoals\n  ...LinkedProjects\n  ...WorkTrackingLinks\n  ...RelatedLinks\n  ...Milestones @include(if: $areMilestonesEnabled)\n  ...FollowersSidebarSection_ProjectKey\n  milestoneCount: milestones {\n    count\n  }\n  tags {\n    ...Tags\n  }\n  customFields {\n    ...SidebarFields\n  }\n  watchers {\n    ...FollowersSidebarSection\n  }\n  owner {\n    pii {\n      ...FollowersSidebarSection_Owner\n    }\n    id\n  }\n  ...ProjectStartDate\n}\n\nfragment ProjectStartDate on Project {\n  id\n  startDate\n  ...ProjectStartDatePicker\n}\n\nfragment ProjectStartDatePicker on Project {\n  startDate\n  targetDate\n  targetDateSet\n  creationDate\n  state {\n    value\n  }\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  projectStateValue: value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectStateAndTargetDate on Project {\n  state {\n    value\n    atCompletionState {\n      value\n    }\n  }\n  creationDate\n  startDate\n  targetDate\n  targetDateConfidence\n}\n\nfragment ProjectTabs on Project {\n  id\n  key\n  watching\n  userUpdateCount\n  learningsCount: learnings(first: 100, type: LEARNING) {\n    edges {\n      __typename\n      cursor\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  risksCount: learnings(first: 100, type: RISK) {\n    edges {\n      __typename\n      cursor\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  decisionsCount: learnings(first: 100, type: DECISION) {\n    edges {\n      __typename\n      cursor\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...ProjectAboutTab\n  ...ProjectUpdatesTab\n}\n\nfragment ProjectTargetDateAutoUpdated on Project {\n  key\n  targetDate\n  changelog(hasUpdateId: false) {\n    count\n    edges {\n      node {\n        newValue\n        oldValue\n        id\n      }\n    }\n  }\n}\n\nfragment ProjectUpdateComposer on Project {\n  ...ProjectUpdateDueDateContext\n  ...NewProjectUpdate\n  draftUpdate {\n    ...DraftUpdate\n    id\n  }\n  id\n  uuid\n  workspace {\n    uuid\n    id\n  }\n}\n\nfragment ProjectUpdateDueDateContext on Project {\n  state {\n    value\n  }\n  latestUpdateDate\n}\n\nfragment ProjectUpdatesTab on Project {\n  key\n  state {\n    value\n  }\n  watching\n  targetDate\n  targetDateConfidence\n  ...ProjectUpdateComposer\n  draftUpdate {\n    id\n  }\n}\n\nfragment RelatedLinks on Project {\n  id\n  relatedLinks: links(type: RELATED) {\n    ...ProjectLinks\n  }\n}\n\nfragment RemoveMemberButton on User {\n  id\n  aaid\n  pii {\n    name\n  }\n}\n\nfragment SelectField on TextSelectCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on TextSelectCustomFieldDefinition {\n      name\n      description\n      canSetMultipleValues\n      allowedValues {\n        edges {\n          node {\n            id\n            value\n          }\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  values {\n    edges {\n      node {\n        id\n        value\n      }\n    }\n  }\n}\n\nfragment SidebarFields on CustomFieldConnection {\n  edges {\n    node {\n      __typename\n      ... on TextCustomField {\n        ...FreeformTextField\n      }\n      ... on NumberCustomField {\n        ...FreeformNumberField\n      }\n      ... on UserCustomField {\n        ...UserField\n      }\n      ... on TextSelectCustomField {\n        ...SelectField\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment Tag on Tag {\n  ...Tag_createTagOption\n}\n\nfragment Tag_createTagOption on Tag {\n  id\n  name\n  uuid\n  description\n  projectUsageCount\n  goalUsageCount\n  helpPointerUsageCount\n  watcherCount\n}\n\nfragment Tags on TagConnection {\n  edges {\n    node {\n      id\n      uuid\n      name\n      ...Tag\n      ...Tag_createTagOption\n    }\n  }\n}\n\nfragment TeamAndMembersItem_OtPnR on Team {\n  ...TeamItem_OtPnR\n  name\n  id\n  teamId\n  teamDetails {\n    membershipSettings\n  }\n  permission(cloudId: $cloudId)\n  membersOfProject(key: $key) {\n    edges {\n      node {\n        aaid\n        ...UserItem\n        id\n      }\n    }\n  }\n}\n\nfragment TeamAvatar on Team {\n  id\n  name\n  teamId\n  teamDetails {\n    isVerified\n  }\n  avatarUrl\n}\n\nfragment TeamItem_OtPnR on Team {\n  id\n  name\n  teamId\n  ...TeamAvatar\n  ...TeamOptionsMenu_OtPnR\n}\n\nfragment TeamOptionsMenu_OtPnR on Team {\n  id\n  teamId\n  name\n  watching\n  permission(cloudId: $cloudId)\n  teamDetails {\n    membershipSettings\n  }\n  membersOfProject(key: $key) {\n    edges {\n      node {\n        aaid\n        ...UserItem\n        id\n      }\n    }\n  }\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_1TWJ92 on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n    extendedProfile {\n      jobTitle\n    }\n  }\n}\n\nfragment UserField on UserCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on UserCustomFieldDefinition {\n      name\n      description\n      canSetMultipleValues\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  values {\n    edges {\n      node {\n        id\n        aaid\n        ...UserAvatar_1TWJ92\n      }\n    }\n  }\n}\n\nfragment UserItem on User {\n  ...UserAvatar_1TWJ92\n  ...RemoveMemberButton\n}\n\nfragment WorkTrackingLinks on Project {\n  id\n  uuid\n  key\n  ari\n  workTrackingLinks: links(type: WORK_TRACKING, first: 1) {\n    edges {\n      node {\n        id\n        url\n      }\n    }\n  }\n  fusion {\n    synced\n  }\n  workspace {\n    site {\n      productActivations {\n        edges {\n          node {\n            __typename\n            ... on JiraProductActivation {\n              atlasForJiraCloudEnabled\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n  ...GenericWorkTrackingLinks\n}\n\nfragment metricTargetPopup on Goal {\n  id\n  progress {\n    type\n    percentage\n  }\n  subGoals {\n    count\n  }\n  metricTargets {\n    edges {\n      node {\n        ...metricTarget_direct\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment metricTarget_direct on MetricTarget {\n  startValue\n  targetValue\n  snapshotValue {\n    value\n    id\n  }\n  metric {\n    id\n    name\n    type\n    subType\n    archived\n  }\n}\n\nfragment progressBarMetricTarget on Goal {\n  progress {\n    type\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          type\n          subType\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment useRedirectToDefaultTab on Project {\n  watching\n  key\n}\n\nfragment utils_isUserInList on UserConnection {\n  edges {\n    node {\n      aaid\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e0bc42450ff719b9499e776e20475417";

export default node;
